<template>
    <div class="manage">
        <div style="margin: 0px;" class="top">

            <el-row>
                <el-col :span="24" class="table" style="margin: 0px;">
                    <div ref="height_top">
                        <el-table ref="tableRef" :data="tableData" :height="tableHeight"
                            @selection-change="handleSelectionChange"
                            :header-cell-style="{ 'background-color': '#e5e5e5' }" size="small" v-loading="loading"
                            style="width: 100%;" :row-class-name="tableRowClassName">
                            <el-table-column type="selection" width="55" header-align="center" align="center"
                                :selectable="selectable" />
                            <el-table-column prop="img" label="实图" width="80" header-align="center"
                                show-overflow-tooltip>
                                <template #default="scope">
                                    <div v-if="scope.row.img.length <= 0">
                                        <div @click="preview(scope.row, scope.row.img)">
                                            <el-image style="" :src="require('@/assets/img/error_img.png')"
                                                loading="lazy" />
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div @click="preview(scope.row, scope.row.img)">
                                            <el-image :src="scope.row.img[0]" loading="lazy" />
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="" width="20" />
                            <el-table-column prop="stock_type_txt" label="货物状态" header-align="center" width="170"
                                show-overflow-tooltip>
                                <template #default="scope">
                                    <div class="stock_type_txt_button">
                                        <span v-for="item in scope.row.stock_type_txt_list">
                                            <el-button class="A" size="small" text bg
                                                v-if="item == '二手' || item == '过保' || item == '包附破损'" style="">{{ item
                                                }}</el-button>
                                            <el-button class="C" size="small" text bg v-else color="#ff8a5c">{{
                                                item }}</el-button>
                                        </span>
                                    </div>
                                    <!-- <el-button-group class="ml-4">
										    <el-button size="small"/>
										    <el-button size="small" />
										    <el-button size="small" />
										  </el-button-group> -->
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="" width="20" />
                            <el-table-column prop="brand_name" label="产品信息" show-overflow-tooltip>
                                <template #default="scope">
                                    <div class="product-info">
                                        <div class="brand-name" v-if="scope.row.brand_name">
                                            {{ scope.row.brand_name }}
                                        </div>
                                        <div class="product-name" v-if="scope.row.name">
                                            {{ scope.row.name }}
                                        </div>
                                        <div class="product-details" v-if="scope.row.model">
                                            <span class="detail-label">型号</span><span class="label-colon">：</span>
                                            <span class="detail-value">{{ scope.row.model }}</span>
                                        </div>
                                        <div class="product-details" v-if="scope.row.order_no">
                                            <span class="detail-label">订货号</span><span class="label-colon">：</span>
                                            <span class="detail-value">{{ scope.row.order_no }}</span>
                                        </div>
                                        <div class="product-details" v-if="scope.row.unit">
                                            <span class="detail-label">单位</span><span class="label-colon">：</span>
                                            <span class="detail-value">{{ scope.row.unit }}</span>
                                        </div>
                                        <div class="product-user-type" v-if="scope.row.type_name">
                                            <span class="detail-label">用户类型</span><span class="label-colon">：</span>
                                            <span class="detail-value">{{ scope.row.type_name }}</span>
                                        </div>
                                        <span
                                            v-if="!scope.row.brand_name && !scope.row.name && !scope.row.model && !scope.row.order_no">
                                            -
                                        </span>

                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column prop="" label="" width="20" />
                            <el-table-column prop="tsw_price" align="center" header-align="center" label="单价"
                                :width="td_width['tsw_price']" show-overflow-tooltip>

                                <template #default="scope">
                                    <el-tooltip placement="top">
                                        <template #content>
                                            <p>此信息由用户提供，仅供参考，请与发布用户核实！</p>
                                        </template>
                                        <span class="price-value">{{ scope.row.tsw_price }}</span>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="" width="20" />
                            <el-table-column prop="inve_num" label="库存" :width="td_width['sur_num']" align="center"
                                header-align="center" show-overflow-tooltip>
                                <template #default="scope">
                                    <div class="stock-cell">
                                        <span v-if="scope.row.isexpire == 1" class="stock-warning">
                                            库存不足
                                        </span>
                                        <span v-else class="stock-value"
                                            :class="{ 'stock-disabled': scope.row.isexpire == 1 }">{{ scope.row.inve_num
                                            }}</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="" width="20" />
                            <el-table-column prop="num" label="数量" width="230" align="center" header-align="center"
                                show-overflow-tooltip>
                                <template #default="scope">
                                    <div style="margin: 10px" @click.stop @dblclick.stop>
                                        <el-input-number class="num-input" v-model="scope.row.num" :min="1"
                                            :max="scope.row.inve_num" @change="(val) => handleChange(scope.row, val)"
                                            @click.stop @dblclick.stop :disabled="scope.row.isexpire == 1" />
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="" width="20" />
                            <el-table-column prop="tsw_price" align="center" header-align="center" label="金额"
                                :width="td_width['tsw_price']" show-overflow-tooltip>
                                <template #default="scope">
                                    <span class="price-value">{{ scope.row.tsw_money }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="" width="20" />
                            <el-table-column label="操作" width="80" header-align="center" align="center"
                                v-if="!isReorder">
                                <template #default="scope">
                                    <el-icon style="cursor: pointer; color: #f56c6c;" @click="handleDelete(scope.row)">
                                        <Delete />
                                    </el-icon>
                                </template>
                            </el-table-column>

                        </el-table>
                    </div>
                </el-col>

            </el-row>

            <!-- 底部合计区域 -->
            <el-row class="footer-bar">
                <el-col :span="4" class="footer-right">
                    <div class="total-section">
                        <div class="total-label">总金额：</div>
                        <div class="total-amount">¥{{ totalAmount }}</div>
                    </div>
                    <el-button class="pay-btn" type="primary" @click="handlePay" :loading="paying">创建订单</el-button>
                </el-col>
            </el-row>
        </div>
    </div>
    <examineImg ref="examineImg"></examineImg>

</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import { Delete } from '@element-plus/icons-vue'
import '../../assets/user/index.css' //优化表格样式
import examineImg from '../public/img';
export default {
    components: {
        examineImg
    },
    data() {

        return {
            SelectionChangeId: [],
            selectedRows: [],
            srcList: [],
            tableData: [],
            form: {
                name: '',
                userinfo: '',
                type: '',
            },
            loading: false,
            paying: false,
            total: 0,
            page: 1,
            tableHeight: 400,
            page_size: 120,
            user_id: '',
            isReorder: false,
            td_width: {
                brand_name: 300,
                tsw_price: 130,
                sur_num: 130,
                chat: 60,
                price: 80
            },

        }
    },
    props: [],

    updated() {

    },


    mounted() {

    },

    activated() {

    },
    created() {
        this.tableHeight_fun()
        this.user_id = localStorage.getItem('user_id');
        // 检查是否有订单号参数，有则设置重新下单标志并隐藏删除按钮
        const pay_no = this.$route.query.pay_no;
        if (pay_no) {
            this.isReorder = true;
        }
        this.search();
    },
    watch: {

    },
    computed: {
        totalAmount() {
            return this.calcTotalAmount();
        }
    },
    methods: {
        tableRowClassName({ row, rowIndex }) {
            if (row.isexpire == 1) {
                return 'expired-row';
            }
            return '';
        },
        selectable(row, index) {
            return row.isexpire != 1;
        },
        preview(row, img) {
            this.srcList = [];
            var obj = this;
            img.forEach(function (item) {
                obj.srcList.push(item)
            })
            this.$refs['examineImg'].img_title = row;
            this.$refs['examineImg'].data = this.srcList;
            this.$refs['examineImg'].dialogTableVisible = true;
            this.$refs['examineImg'].imgBigUrl = this.srcList[0];
        },
        handleDelete(row) {
            ElMessageBox.confirm(
                '确认删除该商品？',
                '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            }
            )
                .then(() => {
                    this.$axios.post('/api/yunsys.Cart/delcart', { id: row.id })
                        .then(res => {
                            var res = res.data;
                            if (res.code !== 0) {
                                return ElMessage({
                                    message: res.msg,
                                    type: 'error',
                                    grouping: true
                                });
                            }
                            const index = this.tableData.findIndex(item => item.id === row.id);
                            if (index !== -1) {
                                this.tableData.splice(index, 1);
                                ElMessage.success('删除成功');
                            }
                        })
                        .catch(err => {
                            console.log(err);
                            return ElMessage({
                                message: '系统错误',
                                type: 'error',
                                grouping: true
                            });
                        });
                })
                .catch(() => { });
        },
        // 计算单行金额
        calcRowMoney(row) {
            if (row && row.num && row.tsw_price) {
                row.tsw_money = this.$bn.multiply(row.num, row.tsw_price, 2);
            }
        },
        // 计算总金额（只计算勾选行）
        calcTotalAmount() {
            let total = '0';
            this.selectedRows.forEach(item => {
                total = this.$bn.add(total, item.tsw_money || 0, 2);
            });
            return total;
        },
        handleSelectionChange(data) {
            var ids = [];
            data.forEach(function (item) {
                ids.push(item.id);
            })
            this.SelectionChangeId = ids;
            this.selectedRows = data;
        },
        handleChange(row, val) {
            // 更新单行金额
            this.calcRowMoney(row);
        },
        handlePay() {
            if (this.SelectionChangeId.length === 0) {
                ElMessage.warning('请选择商品！');
                return;
            }
            if (this.paying) {
                return;
            }
            this.paying = true;
            ElMessageBox.confirm(
                '确认创建订单信息，需等待商家确认！',
                '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            }
            )
                .then(() => {
                    var goods = this.selectedRows.map(function (item) {
                        return {
                            id: item.id,
                            product_order_no: item.order_no,
                            num: item.num
                        };
                    });
                    const pay_no = this.$route.query.pay_no;
                    this.$axios.post('/api/yunsys.Order/addbills', { goods: goods, pay_no: pay_no })
                        .then(res => {
                            var res = res.data;
                            this.paying = false;
                            if (res.code !== 0) {
                                return ElMessage({
                                    message: res.msg,
                                    type: 'error',
                                    grouping: true
                                });
                            }
                            ElMessage.success('创建订单成功');
                            this.$router.push('/user?type=orderList');
                        })
                        .catch(err => {
                            console.log(err);
                            this.paying = false;
                            return ElMessage({
                                message: '系统错误',
                                type: 'error',
                                grouping: true
                            });
                        });
                })
                .catch(() => {
                    this.paying = false;
                })
            // 后续可添加支付逻辑
        },
        header_table(event) {
            if (event.column.property == 'header') {
                return { 'background-color': '#fff' }
            } else {
                return { 'background-color': '#e5e5e5' }
            }

        },
        grabble() {
            this.page = 1;
            this.search();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.search();
        },
        tableHeight_fun() {
            this.$nextTick(() => {
                this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 130
                console.log(this.tableHeight)
            })
        },
        async search() {
            if (this.loading) {
                return false;
            }
            this.loading = true;
            const pay_no = this.$route.query.pay_no;
            const apiUrl = pay_no ? '/api/yunsys.Order/reorder' : '/api/yunsys.Cart/getcart';
            const params = pay_no ? { pay_no: pay_no } : {};
            await this.$axios.post(apiUrl, params)
                .then(async (res) => {
                    var res = res.data;
                    this.loading = false;
                    if (res.code !== 0) {
                        return ElMessage({
                            message: res.msg,
                            type: 'error',
                            grouping: true // 开启合并功能
                        });
                    }
                    var obj = this;
                    res.data.forEach(item => {
                        item.stock_type_txt_list = item.stock_type_txt.split("、");
                        item.tsw_price = obj.$bn.multiply(item.tsw_price, 1, 2);
                        item.tsw_money = obj.$bn.multiply(item.num, item.tsw_price, 2);
                    });
                    this.tableData = res.data;
                    this.$nextTick(() => {
                        if (this.$refs.tableRef) {
                            this.$refs.tableRef.toggleAllSelection();
                        }
                    });
                })
                .catch(err => {
                    console.log(err);
                    this.loading = false;
                    return ElMessage({
                        message: '系统错误',
                        type: 'error',
                        grouping: true // 开启合并功能
                    });
                });
        },

    }
}
</script>
<style lang="less" scoped>
:deep(thead tr:first-child .cell) {
    padding: 0px
}

:deep(.el-table__row .el-table__cell:nth-child(2)) {
    .el-tooltip {
        padding: 0px;
    }
}

.stock_type_txt_button .el-button {
    margin-right: 5px;
    font-size: 0.70rem !important;
    padding: 0.2525rem 0.5875rem;
}

.stock_type_txt_button .A {
    color: red !important;
    background-color: rgb(255, 240, 228) !important;
}

.stock_type_txt_button .B {
    color: red;
    background-color: rgb(255, 243, 245) !important;
}

.stock_type_txt_button .C {
    color: rgb(75, 212, 205);
    background-color: rgb(223, 255, 251) !important;
}

:deep(.el-input-group__append) {
    background: #ff8a5c;
}

:deep(.num-input .el-input__wrapper) {
    box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color)) inset !important;
}


:deep(.district .el-input-group__prepend) {
    background-color: #fff;
    color: #ff8a5c;
}

:deep(.district .el-input-group__append) {
    background-color: #fff;
    color: #ff8a5c;
}

:deep(.el-image) {
    border-radius: 3px;
    height: 60px;
    width: 60px;
    display: inline-block;
    display: flex;
}

:deep(.acquiesce .el-button) {

    border: 0;
}

:deep(.info .el-button:hover) {
    color: #fff;
    background-color: #ff8a5c;
    border-color: #ff8a5c;
}

:deep(.name .el-button:hover) {
    color: #ff8a5c;
}

:deep(.name .el-button:active) {
    color: #ff8a5c;
}

:deep(.el-pagination.is-background .el-pager li.is-active) {
    background-color: #ff8a5c;
}

:deep(.el-form-item__label) {
    font-size: 13px;
}

:deep(.el-form-item) {

    margin-bottom: 8px;
}

:deep(.el-input-group__append) {

    background: #ff8a5c;
}

:deep(.expired-row) {
    background-color: #f5f5f5 !important;
    color: #999 !important;
}

:deep(.expired-row .el-input-number) {
    opacity: 0.5;
}

.logo_m {
    margin: 15px 0px 15px 0px;
    height: auto;
}

.product-info {
    padding: 8px 0;
}

.product-tags {
    margin-bottom: 6px;
}

.product-tags .el-tag {
    margin-right: 6px;
    margin-bottom: 4px;
}

.brand-name {
    font-weight: bold;
    color: #333;
    font-size: 14px;
    margin-bottom: 4px;
}

.product-name {
    color: #666;
    font-size: 13px;
    margin-bottom: 4px;
}

.product-details {
    color: #999;
    font-size: 12px;
    margin-bottom: 3px;
    display: flex;
    align-items: center;
}

.detail-label {
    display: inline-block;
    width: 48px;
    text-align: justify;
    text-align-last: justify;
    text-justify: inter-character;
}

.label-colon {
    margin-right: 8px;
}

.detail-value {
    flex: 1;
}

.product-user-type {
    color: #666;
    font-size: 12px;
    margin-top: 4px;
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}

.price-value {
    color: #ff8a5c;
    font-size: 16px;
    font-weight: bold;
}

.price-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.inquiry-btn {
    color: #ff8a5c;
    font-size: 13px;
    padding: 0;
}

.inquiry-btn:hover {
    color: #ff6b3d;
}

.off-shelf {
    color: #999;
    font-size: 12px;
}

.stock-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 4px;
}

.stock-value {
    font-size: 13px;
    color: #333;
}

.stock-disabled {
    color: #999;
}

.stock-warning {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 2px 8px;
    background-color: #fff1f0;
    color: #cf1322;
    font-size: 12px;
    border-radius: 4px;
    border: 1px solid #ffccc7;
}

/* 底部合计区域样式 */
.footer-bar {
    background: #fff;
    border-top: 1px solid #e8e8e8;
    padding: 15px 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.footer-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 20px;
}

.total-section {
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
}

.total-label {
    font-size: 14px;
    color: #666;
    font-weight: 500;
    white-space: nowrap;
}

.total-amount {
    font-size: 24px;
    color: #ff8a5c;
    font-weight: bold;
    white-space: nowrap;
}

.pay-btn {
    background: linear-gradient(135deg, #ff8a5c 0%, #ff6b3d 100%);
    border: none;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    padding: 12px 36px;
    border-radius: 25px;
    box-shadow: 0 4px 12px rgba(255, 138, 92, 0.4);
    transition: all 0.3s ease;
}

.pay-btn:hover {
    background: linear-gradient(135deg, #ff6b3d 0%, #ff5a2b 100%);
    box-shadow: 0 6px 16px rgba(255, 138, 92, 0.5);
    transform: translateY(-2px);
}

.pay-btn:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(255, 138, 92, 0.4);
}

.chat-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

:deep(.el-table__body-wrapper tr.el-table__row.selected) td {
    border-top: 1px solid #ff8a5c !important;
    border-bottom: 1px solid #ff8a5c !important;
}

:deep(.el-table__body-wrapper tr.el-table__row.selected td:first-child) {
    border-left: 1px solid #ff8a5c !important;
}

:deep(.el-table__body-wrapper tr.el-table__row.selected td:last-child) {
    border-right: 1px solid #ff8a5c !important;
}

/* 多选框选中颜色 */
:deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
    background-color: #ff8a5c;
    border-color: #ff8a5c;
}

:deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner) {
    background-color: #ff8a5c;
    border-color: #ff8a5c;
}

/* 多选框移入边框颜色 */
:deep(.el-checkbox__input:hover .el-checkbox__inner) {
    border-color: #ff8a5c;
}

/* 小屏幕 (平板, 768px 及以上) */
@media (min-width: 768px) {
    .search_remark {
        width: 120px;
    }
}

/* 中等屏幕 (桌面, 992px 及以上) */
@media (min-width: 992px) {
    .search_remark {
        width: 170px;
    }
}

/* 大屏幕 (大桌面, 1600px 及以上) */
@media (min-width: 1600px) {
    .search_remark {
        width: 400px;
        margin-left: 60px
    }
}

/* 超大屏幕 (更大桌面, 1920px 及以上) */
@media (min-width: 1920px) {
    .search_remark {
        width: 400px;
        margin-left: 60px
    }
}
</style>